<template>
  <div>
    <b-card :title="cardTitle">
      <b-row class="d-flex justify-content-center align-items-center">
        <b-col>
          <b-form-group
            label="Başlangıç Tarihi"
            label-for="sdate"
          >
            <b-form-datepicker
              v-model="buyTypesParams.sdate"
              v-bind="{labelNoDateSelected: 'Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="tr"
              start-weekday="1"
              @input="getReportData"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Bitiş Tarihi"
            label-for="edate"
          >
            <b-form-datepicker
              v-model="buyTypesParams.edate"
              v-bind="{labelNoDateSelected: 'Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="tr"
              start-weekday="1"
              @input="getReportData"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCol, BFormDatepicker, BFormGroup, BRow, BCard,
} from 'bootstrap-vue'

export default {
  name: 'I2SalesBuyTypesFilter',
  components: {
    BFormDatepicker, BFormGroup, BCol, BRow, BCard,
  },
  props: {
    cardTitle: {
      type: String,
      default: null,
    },
    getReportData: {
      type: Function,
      required: true,
    },
  },
  computed: {
    buyTypesParams() {
      return this.$store.getters['i2SalesReports/buyTypesParams']
    },
  },
}
</script>
